const { get } = require('lodash');

module.exports = function(value) {
  return get(value, ['value'], {});
};
